import validateForm from './validateForm';

//import FormRecaptcha from './FormRecaptcha';

//const formRecaptcha = new FormRecaptcha();

const setFormState = ($form, valid, invalidFields) => {

  $form.toggleClass('invalid', !valid);
  $('.invalid', $form).removeClass('invalid');
  invalidFields.forEach((field) => {
      const $inputWrapper = $(field).closest("label");
      
    if (!$inputWrapper.hasClass('pristine')) {
      $inputWrapper.addClass('invalid');
    }
  });
  
    var $suburbFooter = $(".suburb-foot", $form);
    var $suburbcodeField = $('[name="suburb"]', $form);
    var $postcodeField = $('[name="postcode"]', $form);
    var errorPostcodeBody = '<span id="peetPostCodeError" class="field-validation-error peet-postcode-error">Please select a suburb from the dropdown.<br /></span>';
    var errorPostcode = $('[id="peetPostCodeError"]', $form);

    if ($suburbcodeField && $suburbcodeField.length > 0) {
        var $suburb = $suburbcodeField.val();

        if ($suburb) {            
            if (errorPostcode.length > 0)
            {
                errorPostcode.remove();
			}            
        }
        else
        {
            if ($postcodeField.hasClass('invalid'))
            {
                if (errorPostcode.length < 1)
                {
                    $suburbFooter.before(errorPostcodeBody);
                }                
            }
            else
            {
                if (errorPostcode.length < 1)
                {
                    $suburbFooter.before(errorPostcodeBody);
                }
            }
        }
    }

    $('[type="submit"]', $form).attr('disabled', !valid);  
};

const watchForm = ($form) => {

  // Does the form have recaptcha, if so execute recaptcha
  //const $recaptcha = $('[data-sitekey]', $form); 
  //if ($recaptcha.length > 0) {
  //  formRecaptcha.init($form);
  //  formRecaptcha.execute();
  //}

  const $watchedFields = $('[required="required"]', $form);
  const $submitButton = $('[type="submit"]', $form);
  const $suburbcodeField = $('[name="suburb"]', $form);
  $watchedFields.closest("label").addClass('pristine');
  if ($watchedFields.length) {
    $submitButton.attr('disabled', true);
   }  

  $watchedFields.on('keyup change blur focus', async ({ target }) => {
      $(target).closest("label").removeClass('pristine');
    const { valid, invalidFields } = await validateForm($watchedFields);
    setFormState($form, valid, invalidFields);
  });



  $submitButton.closest('.form__control-group--submit').on('click', async (e) => {
    
    //const disabled = $('button[type="submit"]', this).prop('disabled');

    //console.log("submit closest: ", e);

    //if ($recaptcha.length > 0) {
    //    if (!disabled && !formRecaptcha.isValid ) {
    //        formRecaptcha.execute();
    //        e.preventDefault();
    //        return false;
    //    }
    //}

    if ($submitButton.attr('disabled')) {
      try {
        const { valid, invalidFields } = await validateForm($watchedFields, true);
        setFormState($form, valid, invalidFields);
      }
      catch (err) {
        console.log('Error validating form', err); // eslint-disable-line no-console
      }
    }
  });
  return $form;
};

export default watchForm;
